module.exports = __webpack_public_path__ + "img/tongue-twister-sprite.f746beb4.png";